var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('append-to-body',{staticClass:"close-todo-alarm"},[_c('close-alarm',{ref:"closeAlarm",on:{"onHide":function($event){return _vm.$emit('closeButtonClicked')},"onClose":_vm.submit}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-640a230c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/notification/closeTodoAlarm.vue
// module id = null
// module chunks = 